import { TagDetailsFormBaseDataProvider } from './TagDetailsFormBaseDataProvider';
import { TagDetailsFormViewData } from '../types/TagDetailsFormViewData';

export class TagDetailsFormGzDataProvider extends TagDetailsFormBaseDataProvider {
  async getDataForView(): Promise<TagDetailsFormViewData> {
    return {} as unknown as TagDetailsFormViewData;
  }
}
